module.exports = __webpack_public_path__ + "img/back_Blank.ead3e60d.svg";